var _defs, _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDeactivated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b17eac61-055d-4b8e-baea-08d82b4114ad",
    "data-name": "C-wires layered OFF",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 843.47 200.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".C-wire-channel,.fd293ffe-5c6e-43a5-9e7a-1c2ac96067e9{fill:none;}.C-wire-channel{stroke:#d2e4f9;stroke-linecap:round;stroke-linejoin:round;stroke-width:9px;}.fd293ffe-5c6e-43a5-9e7a-1c2ac96067e9{stroke:#b290d1;stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "af8817d2-afd9-4d9a-a116-dc6454f16440",
    "data-name": "Channel"
  }, /*#__PURE__*/React.createElement("path", {
    className: "C-wire-channel",
    d: "M19,14.48V72.66a4,4,0,0,0,4,4H151.79a4,4,0,0,1,2,.53l163.86,94.49a4,4,0,0,0,4,0l87.18-50.56a4,4,0,0,1,4,0l111,64.38a3.93,3.93,0,0,0,2,.54l224.31-.3a4,4,0,0,0,2-.52l34.3-19.52a4,4,0,0,0,2-3.47V117.78a4,4,0,0,1,2-3.46l34-19.75"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "e9f873d3-f30d-4861-b0e6-cae87fd3d1b9",
    "data-name": "OFF"
  }, /*#__PURE__*/React.createElement("path", {
    className: "C-wire-channel",
    d: "M19,14.48V72.66a4,4,0,0,0,4,4H151.79a4,4,0,0,1,2,.53l163.86,94.49a4,4,0,0,0,4,0l87.18-50.56a4,4,0,0,1,4,0l111,64.38a3.93,3.93,0,0,0,2,.54l224.31-.3a4,4,0,0,0,2-.52l34.3-19.52a4,4,0,0,0,2-3.47V117.78a4,4,0,0,1,2-3.46l34-19.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fd293ffe-5c6e-43a5-9e7a-1c2ac96067e9",
    d: "M19,14.48V72.66a4,4,0,0,0,4,4H151.79a4,4,0,0,1,2,.53l163.86,94.49a4,4,0,0,0,4,0l87.18-50.56a4,4,0,0,1,4,0l111,64.38a3.93,3.93,0,0,0,2,.54l224.31-.3a4,4,0,0,0,2-.52l34.3-19.52a4,4,0,0,0,2-3.47V117.78a4,4,0,0,1,2-3.46l34-19.75"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivated);
export default __webpack_public_path__ + "static/media/deactivated.eb467b0a.svg";
export { ForwardRef as ReactComponent };